<div>
    <nz-alert *ngIf="isFromSetPassword" nzType="success"
        nzMessage="You have successfully set your password. Please use your new password to log in below."
        nzShowIcon></nz-alert>
    @if(isModal) {
    <div id="login-modal-header">
        Log In
    </div>
    }
    <div id="login-container">
        <div id="login-form-container" [ngClass]="{'login-form-container-page': !isModal}">
            <nz-card nzType="inner" nzBorderless>
                <form nz-form [formGroup]="form" class="login-form" (ngSubmit)="onLogin()">
                    <nz-alert *ngIf="loginError as loginError" nzType="error" nzShowIcon nzMessage="Login Failed"
                        [nzDescription]="errorDescription">
                        <ng-template #errorDescription><span [innerHTML]="loginError"></span></ng-template>
                    </nz-alert>
                    <div *ngIf="unknownErrorMessages.length > 0">
                        <nz-alert nzType="error" *ngFor="let message of unknownErrorMessages" [nzMessage]="message"
                            nzShowIcon></nz-alert>
                    </div>
                    <mat-form-field id="login-email-input" class="email-input" appearance="outline"
                        subscriptSizing="dynamic">
                        <mat-label>Email</mat-label>
                        <input type="email" matInput formControlName="email" autocomplete="email" required />
                        @if (form.get('email').invalid) {
                        <mat-error id="login-email-error">{{ getErrorMessage('email') }}</mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field id="login-password-input" class="password-input" appearance="outline"
                        class="password-control" subscriptSizing="dynamic">
                        <mat-label>Password</mat-label>
                        <input [type]="showPassword ? 'text' : 'password'" matInput formControlName="password"
                            autocomplete="password" required />
                        <mat-icon matSuffix (click)="showPassword = !showPassword" id="password-visibility-toggle">
                            <i *ngIf="!showPassword" class="fa-solid fa-eye"></i>
                            <i *ngIf="showPassword" class="fa-solid fa-eye-slash"></i>
                        </mat-icon>
                        @if (form.get('password').invalid) {
                        <mat-error id="login-password-error">{{ getErrorMessage('password') }}</mat-error>
                        }
                    </mat-form-field>
                    <a class="login-form-forgot" class="login-form-forgot" (click)="onForgotPassword()">Forgot your
                        password?</a>
                    <button id="login-button" class="hill-button-secondary login-button" type="submit"
                        [disabled]="isAuthenticating">
                        <span class="loading-icon" *ngIf="isAuthenticating" nz-icon nzType="loading"
                            nzTheme="outline"></span> Log in
                    </button>
                </form>
                @if (!isModal) {
                <nz-divider></nz-divider>
                <div class="form-section-helper-text">
                    <span>Don't have an account yet?</span>
                </div>
                <button id="login-registration" class="hill-button-secondary-outline register-button"
                    (click)="onCreateAccount()">
                    Create an account
                </button>
                }

            </nz-card>
        </div>
        @if (isModal) {
        <div class="vertical-divider"></div>
        <div id="login-modal-second-col">
            <button id="login-continue-as-guest" class="hill-button-secondary-outline register-button"
                (click)="onContinueAsGuest()">
                Continue as guest
            </button>
            <nz-divider></nz-divider>
            <div class="form-section-helper-text-modal">
                <span>Don't have an account yet?</span>
            </div>
            <button id="login-registration" class="hill-button-secondary-outline register-button"
                (click)="onCreateAccount()">
                Create an account
            </button>
        </div>
        }
    </div>
</div>